import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./MenuBottom.module.scss";
import VIEWS from "./views.js";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import iconTop from "../../assets/img/iconTop.png";
import iconBack from "assets/img/iconBack.png";
import { ClickAwayListener } from "@material-ui/core";
import Principal from "../Menu/Principal/Principal";
import Favorites from "../Menu/Favorites/Favorites";
import FAQ from "../Menu/FAQ/FAQ";
import menu from "assets/img/menu.png";

import { iconBottom } from "assets/images";
import About from "components/Menu/About/About";
const useStyles = makeStyles({
    list: {
        width: 250
    },
    fullList: {
        width: "300px"
    }
});

export default function TemporaryDrawer(props) {
    const classes = useStyles();
    const [state, setState] = React.useState({
        bottom: false
    });

    const [view, setView] = useState(VIEWS.MENU_PRINCIPAL);

    const toggleDrawer = (side, open) => event => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [side]: open });
    };

    const renderUi = (vw = view) => {
        switch (vw) {
            case VIEWS.MENU_PRINCIPAL:
                return (
                    <div>
                        <h2
                            onClick={toggleDrawer("bottom", false)}
                            className={styles.titlePrincipal}
                        >
                            <img
                                src={iconBottom}
                                alt="Busca"
                                className="iconMenu"
                            />{" "}
                            Ver mais
                        </h2>
                        <Principal
                            setView={setView}
                            estabelecimentos={props.estabelecimentos}
                        />
                    </div>
                );
            case VIEWS.FAVORITOS:
                return (
                    <div>
                        <h2
                            onClick={() => setView(VIEWS.MENU_PRINCIPAL)}
                            className={styles.title}
                        >
                            <img
                                src={iconBack}
                                alt="Voltar"
                                className={styles.iconBack}
                            />
                            Favoritos{" "}
                        </h2>
                        <div className={styles.favorites}>
                            <Favorites
                                setView={setView}
                                setSelectedEstabelecimento={
                                    props.setSelectedEstabelecimento
                                }
                                estabelecimentosFavoritos={
                                    props.estabelecimentosFavoritos
                                }
                                userLocation={props.userLocation}
                                favoritar={props.favoritar}
                                selectedMkr={props.selectedMkr}
                                estabelecimentos={props.estabelecimentos}
                            />
                        </div>
                    </div>
                );
            case VIEWS.FAQ:
                return (
                    <div>
                        <h2
                            onClick={() => setView(VIEWS.MENU_PRINCIPAL)}
                            className={styles.title}
                        >
                            <img
                                src={iconBack}
                                alt="Voltar"
                                className={styles.iconBack}
                            />
                            FAQ{" "}
                        </h2>
                        <FAQ setView={setView} />
                    </div>
                );
            case VIEWS.SOBRE:
                return (
                    <div>
                        <h2
                            onClick={() => setView(VIEWS.MENU_PRINCIPAL)}
                            className={styles.title}
                        >
                            <img
                                src={iconBack}
                                alt="Voltar"
                                className={styles.iconBack}
                            />
                            Sobre{" "}
                        </h2>
                            <About />
                        </div>
                );
            default:
                break;
        }
    };

    const fullList = side => (
        <div className={classes.fullList} role="presentation">
            <List>
                <div className={styles.menuBottom}>{renderUi()}</div>
            </List>
        </div>
    );

    return (
        <div>
            <Button
                onClick={toggleDrawer("bottom", true)}
                className={styles.title}
            >
                <img src={iconTop} alt="Busca" className={styles.iconMenu} />{" "}
                Ver mais
                <img src={menu} alt="Menu" className={styles.menuResponsive} />
            </Button>
            <Drawer anchor="bottom" open={state.bottom}>
                <ClickAwayListener onClickAway={toggleDrawer("bottom", false)}>
                    {fullList("bottom")}
                </ClickAwayListener>
            </Drawer>
        </div>
    );
}
